import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DigitalWalletService } from '../services/digital-wallet.service';

@Injectable()
export class DwDashboardResolver  {
    constructor(private router: Router,
                private readonly dwService: DigitalWalletService,
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.dwService.getCheckDWCustomer()
            .pipe(
                switchMap(
                    async (isDwCustomer) => {
                        if (!isDwCustomer) {
                            await this.router.navigate(['/dashboard']);
                        }

                        return true;
                    },
                ),
            );
    }
}
